(function () {
    angular
        .module('advancedapp')
        .component('newsArticleResults', {
            restrict: 'E',
            bindings: {
                results: '<',
                showmore: '@',
                url: '@',
                rootpageid: '@'
            },
            template: require('./news-article-results.html'),
            controller: controller,
            controllerAs: 'vm'
        });

    controller.$inject = ['$log', '$window', 'search_service', '$timeout'];

    function controller($log, $window, search_service, $timeout) {

        var vm = this;
        vm.limit = limit;
        vm.columnCount = 3;
        vm.articlePositions = 0;//this is how many articles are shown on page
        vm.stopShowingShowMore = false;
        vm.totalCount = 0;
        vm.batchCount = 0;
        vm.batchCountPlusOne = 0;

        function limit() {
            var spacingCount = 0;//if cards take narrow(1space) or wide(2spaces)
            var articleCount = 0;
            var batch = 40;
            var indexToCheck = batch + vm.articlePositions;
            // if there is not enough left in results make a full batch, take the rest
            if (vm.results[indexToCheck] === undefined) {
                for (var j = indexToCheck; j >= 0; j--) {
                    if (vm.results[j] !== undefined) {
                        j++;//increment once because the index 0 we want to be added as a "+1" to below line, otherwise we lose one article
                        indexToCheck = j;
                        vm.stopShowingShowMore = true;
                        break;
                    }
                }
            }

            //only remove remainder if articles are more than 3 and this is not the last batch
            if (indexToCheck > 3 && !vm.stopShowingShowMore) {
                var indexToStart = vm.articlePositions === 0 ? 0 : vm.articlePositions + 1;
                // loop through result from the index after the index where we left off, until the batch size
                for (var i = indexToStart; i < indexToCheck; i++) {
                    // adjust count depending on if the article is promoted and therefore takes up two spaces in the layout
                    spacingCount += vm.results[i].IsPromoted ? 2 : 1;
                    articleCount++;
                }
                //calculate the remaining articles if they do not form a complete new line
                var remainderToRemove = spacingCount % vm.columnCount;
                //remove this remainder from the newly shown batch
                articleCount = articleCount - remainderToRemove;
                vm.articlePositions = vm.articlePositions + articleCount;
                //Note: remainders are only removed if there is a full batch available
            }
            // stop removing remainder if it's last batch
            else if (indexToCheck > 3 && vm.stopShowingShowMore) {
                var indexToStart = vm.articlePositions === 0 ? 0 : vm.articlePositions + 1;
                for (var i = indexToStart; i <= indexToCheck; i++) {
                    articleCount++;
                }
                vm.articlePositions = vm.articlePositions + articleCount;
            } else {
                //grab the number of remaining articles and display them
                if (vm.results[indexToCheck] === undefined) {
                    for (var t = indexToCheck; t >= 0; t--) {
                        if (vm.results[t] !== undefined) {
                            var leftovers = indexToCheck - t;
                            for (y = leftovers; y >= 0; y--) {
                                vm.articlePositions++;
                            }
                        }
                    }
                }
            }
            vm.totalCount = vm.results.length;
            vm.batchCount = vm.articlePositions;
            vm.batchCountPlusOne = vm.articlePositions + 1;
        }

        vm.$onChanges = function (changesObj) {
            if (changesObj.results && changesObj.results.currentValue) {
                vm.results = changesObj.results.currentValue;
                vm.articlePositions = 0;
                if (vm.results != null && vm.results.length > 0) {
                    vm.limit();
                }
            }
        };

        vm.showmoreResult = function () {
            vm.limit();
            $timeout(function () {
                Foundation.reInit($('[data-equalizer]'));
            }, 100);
        };
    }
})();